import { render, staticRenderFns } from "./SupplierInvoice.vue?vue&type=template&id=56a82c62&scoped=true"
import script from "./SupplierInvoice.vue?vue&type=script&lang=js"
export * from "./SupplierInvoice.vue?vue&type=script&lang=js"
import style0 from "./SupplierInvoice.vue?vue&type=style&index=0&id=56a82c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a82c62",
  null
  
)

export default component.exports